import * as React from "react";
import * as ReactDOM from "react-dom";
import { App, type AppConfig } from "./App";

/**
 * Mount an Office add-in task pane. Each app's `index.tsx` is one call:
 *
 *   import { bootstrap } from "@usable/office-shell";
 *   import { excelToolSchemas, handleExcelToolCall } from "./lib/excel-tools";
 *   bootstrap({ appName: "Excel Assistant", documentNoun: "workbook",
 *               embedToken: "...", dbName: "usable-excel-chat-history",
 *               toolSchemas: excelToolSchemas, onToolCall: handleExcelToolCall });
 *
 * Office.js must be initialized before rendering — Office.onReady() fires when the
 * host is ready to receive API calls.
 */
export function bootstrap(config: AppConfig, containerId = "container"): void {
  Office.onReady(() => {
    ReactDOM.render(<App config={config} />, document.getElementById(containerId));
  });
}

export type { AppConfig };
